class FaqSearch extends HTMLElement {
    constructor() {
      super();
      this.cachedResults = {};
      this.input = document.querySelector('#faq-search');
      this.SearchResults = this.querySelector('[data-predictive-search]');
      
      
      this.searchTerm = '';
      
      this.setupEventListeners();
      document.querySelector('#faq-page').addEventListener('click', (_event)=>{
        
        if (_event.target == this.input) {
          _event.preventDefault();
          return false
        }
        this.SearchResults.classList.add('d-none');
      });
    }
  
    
    

    /**
     * Bind the events on the search input
     */
    setupEventListeners() {
      if (this.input) {
        this.input.addEventListener('input', Utility.debounce((event) => {
          this.onChange(event);
        }, 500).bind(this))
      }

      this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
      this.input.addEventListener('focus', this.onFocus.bind(this));
    }
  
    /**
     * 
     * @returns Search Query with trim value
     */
    getQuery() {
      return this.input.value.trim();
    }
  
    onChange() {
        const newSearchTerm = this.getQuery();
        this.searchTerm = newSearchTerm;
        this.getSearchResults(this.searchTerm);
    }
  
    /**
     * Trigger Form Submit event
     * @param {*} event 
     */
  
    onFormSubmit(event) {
      event.preventDefault();
    }
  
    
    onFocus() {
      const currentSearchTerm = this.getQuery();
  
      if (!currentSearchTerm.length) return;
  
      if (this.searchTerm !== currentSearchTerm) {
        this.onChange();
      }else {
        this.getSearchResults(this.searchTerm);
      }
    }
  
    getSearchResults(searchTerm) {
        const faqItems = document.querySelectorAll('.faq-item');
        const queryKey = searchTerm.replace(" ", "-").toLowerCase();
        let html = '';
      
        if (searchTerm.trim() === '') {
            this.SearchResults.classList.add('d-none');
            faqItems.forEach(item => item.style.display = 'block'); // Show all
            document.querySelector('#faq-scrollspy-navs ul').style.display = 'block';
            document.querySelector('[data-faqsParent]').style.display = 'block';
            document.querySelector('.no-resulte-div').classList.add('d-none');
            return;
        }
      
        const matchingItems = [...faqItems].filter(item => {
          const question = item.querySelector('.faq-question').textContent.toLowerCase();
          return question.includes(searchTerm.toLowerCase());
        });
        if (matchingItems.length == 0) {
            document.querySelector('#faq-scrollspy-navs ul').style.display = 'none';
            document.querySelector('[data-faqsParent]').style.display = 'none';
            document.querySelector('.no-resulte-div').classList.remove('d-none');
        }else{
            document.querySelector('#faq-scrollspy-navs ul').style.display = 'block';
            document.querySelector('[data-faqsParent]').style.display = 'block';
            document.querySelector('.no-resulte-div').classList.add('d-none');
        }

        faqItems.forEach(item => {
          if (matchingItems.includes(item)) {
            item.style.display = 'block'; // Show matched
          } else {
            item.style.display = 'none'; // Hide unmatched
          }
        });
      
        
        this.SearchResults.classList.remove('d-none');
      
        if (!this.cachedResults[queryKey] && searchTerm.trim() !== '') {
          this.cachedResults[queryKey] = html;
        }
      
        
      }
        
  
    

    /**
     * Show Search results container
     */
    showResults(){
        this.predictiveSearchResults.classList.add('show-results');
    }
}
  
customElements.define('faq-search', FaqSearch);
  